import type { PolypadTool, toolOption } from 'comps/learnosity/v1/type/IPolypad';

import { createActionWithPayload } from 'actions/utils';

export const ACTIONS = {
  SET_ACTIVE_TOOL: 'SET_ACTIVE_TOOL',
  SET_ACTIVE_TOOL_OPTION: 'SET_ACTIVE_TOOL_OPTION',
  SET_ACTIVE_TOOL_COLOR: 'SET_ACTIVE_TOOL_COLOR',
  SET_UNDOUBLE_OR_REDOUBLE: 'SET_UNDOABLE_OR_REDOUBLE',
  SET_POLYPAD_ACTIVE: 'SET_POLYPAD_ACTIVE',
} as const;

export const setActiveTool = createActionWithPayload<
  typeof ACTIONS.SET_ACTIVE_TOOL,
  { tool: PolypadTool }
>(ACTIONS.SET_ACTIVE_TOOL);

export const setPloypadActive = createActionWithPayload<
  typeof ACTIONS.SET_POLYPAD_ACTIVE,
  { polypadStatus: boolean }
>(ACTIONS.SET_POLYPAD_ACTIVE);

export const setActiveToolOptions = createActionWithPayload<
  typeof ACTIONS.SET_ACTIVE_TOOL_OPTION,
  { toolsOption: toolOption }
>(ACTIONS.SET_ACTIVE_TOOL_OPTION);

export const setActiveToolColor = createActionWithPayload<
  typeof ACTIONS.SET_ACTIVE_TOOL_COLOR,
  { toolColor: string }
>(ACTIONS.SET_ACTIVE_TOOL_COLOR);

export const setUndoubleOrRedouble = createActionWithPayload<
  typeof ACTIONS.SET_UNDOUBLE_OR_REDOUBLE,
  { isUndo?: boolean; isRedo?: boolean }
>(ACTIONS.SET_UNDOUBLE_OR_REDOUBLE);
